import React, { Component } from "react";
import { Spin } from "antd";
import { parse } from "qs";
import { connect } from "dva";

import Norm from "../../components/NormComponent";
import Self from "../../components/SelfComponent";
import EvaluateList from "../../components/EvaluateList";
import TreeList from "../../components/TreeList";
import { getCurrentBreadCrumbs } from "../../../../../utils/utils";
import Container from "@/components/Container";
import styles from "./index.less";

@connect(({ field, tree }) => ({
  ...tree,
  ...field
}))
class MySelfTree extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const {
      currentProjectId,
      currentProjectName,
      targetOrgId,
      storekey
    } = query;

    this.state = {
      breadcrumb: [],
      currentProjectId,
      currentProjectName,
      targetOrgId,
      selectEvaluateType: 1,
      indexId: null,
      storekey,
      reRender: false
    };
  }

  componentDidMount() {
    const { currentProjectName, storekey } = this.state;
    this.setBreadcrumb(currentProjectName, storekey);
    this.getData();
  }

  setBreadcrumb = (currentProjectName, storekey) => {
    // 面包屑
    const breadcrumb = getCurrentBreadCrumbs({
      currentUrl: {
        context: currentProjectName,
        path: `/supervision/field/tree${window.location.search}`
      },
      isTop: false,
      storekey: storekey || "supservisionProjectBreadcrumb"
    });
    this.setState({
      breadcrumb
    });
  };

  getData = () => {
    // 调接口
    const { indexId } = this.state;
    const { currentselectTreeNodeIndexId } = this.props;
    this.getTree();
    if (indexId || currentselectTreeNodeIndexId) {
      this.getDetail();
    }
  };

  getTree = () => {
    const { dispatch } = this.props;
    const { targetOrgId, currentProjectId } = this.state;
    dispatch({
      type: "tree/fetchFieldTree",
      payload: {
        projectId: currentProjectId,
        targetOrgId
      }
    });
  };

  getDetail = () => {
    const { dispatch, currentselectTreeNodeIndexId } = this.props;
    const { indexId, currentProjectId, targetOrgId } = this.state;
    dispatch({
      type: "field/fetchTreeDetail",
      payload: {
        indexId: indexId || currentselectTreeNodeIndexId,
        targetOrgId,
        projectId: currentProjectId
      },
      callback: () => {
        this.setState({
          reRender: true
        });
      }
    });
    this.setState({
      selectEvaluateType: 2
    });
  };

  handleChangeSelect = ({ type, code }) => {
    this.setState(
      {
        selectEvaluateType: type,
        indexId: code,
        reRender: false
      },
      () => {
        if (type === 2) {
          this.getDetail();
        }
      }
    );
  };

  renderRightSide = () => {
    const { selectEvaluateType, reRender } = this.state;
    const { index, self, evaluateList = [], templateType } = this.props;
    if (selectEvaluateType === 1 || selectEvaluateType === 0) {
      return null;
    }

    return (
      <div className="right-side">
        <Norm
          formType="detail"
          from="evaluate"
          {...index}
          reRender={reRender}
          templateType={templateType}
        />
        <Self type="detail" {...self} reRender={reRender} />
        <EvaluateList list={evaluateList} reRender={reRender} templateType={templateType} />
      </div>
    );
  };

  render() {
    const { breadcrumb, indexId } = this.state;
    const { spinProps } = this.props;

    return (
      <Container breDataSource={breadcrumb} breStates isBreVersion>
        <div className={styles.fieldTree}>
          <Spin {...spinProps}>
            <div className="container">
              <div className="norm-wrap">
                <div className="left-side">
                  <TreeList
                    indexId={indexId}
                    onSelect={this.handleChangeSelect}
                  />
                </div>
                {this.renderRightSide()}
              </div>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default MySelfTree;
